import React, { useEffect, useState } from 'react';
import { Card, Text, Button, Input } from 'v3/components';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LinkIcon from '@mui/icons-material/Link';
import { styles } from './styles';

export default function CreateChecklistWithLink({
  linkName,
  setLinkName,
  linkNameTouched,
  setLinkNameTouched,
  linkNameError,
  expireDays,
  setExpireDays,
  loading = false,
  onCancel,
  onGenerate,
}) {
  const [expireInput, setExpireInput] = useState(String(expireDays ?? 0));
  const linkNameFilled = !!String(linkName || '').trim();

  useEffect(() => {
    setExpireInput(String(expireDays ?? 0));
  }, [expireDays]);

  function clampToZero(n) {
    if (Number.isNaN(n)) return 0;
    return Math.max(0, n);
  }

  function commitExpireValue(nextValue) {
    const n = clampToZero(Number(nextValue));
    setExpireDays(n);
    setExpireInput(String(n));
  }

  return (
    <>
      <Card style={styles.card}>
        <div style={{ marginBottom: 14 }}>
          <div>
            <Text type="regular" weight={700} color="dark">
              Nome do treinamento por link
            </Text>

            <div style={styles.desc}>
              Esse nome aparece para quem responde e ajuda a identificar o link.
            </div>
          </div>
          <div style={{ marginTop: 8 }}>
            <Input
              value={linkName}
              placeholder="Ex: Treinamento de Segurança do Trabalho"
              onChange={e => setLinkName(e?.target?.value ?? '')}
              onBlur={() => setLinkNameTouched(true)}
              disabled={loading}
            />
            {!!linkNameError && (
              <div
                style={{
                  marginTop: 6,
                  color: '#B91C1C',
                  fontWeight: 700,
                  fontSize: 12,
                }}
              >
                {linkNameError}
              </div>
            )}
          </div>
        </div>

        <div style={styles.sectionTitleRow}>
          <div style={styles.sectionTitleIconBox}>
            <ShieldOutlinedIcon style={{ fontSize: 16, color: '#111827' }} />
          </div>
          <Text type="regular" weight={700} color="dark">
            Regras do Link
          </Text>
        </div>

        <div
          style={{
            width: '100%',
            height: 1,
            backgroundColor: '#D1D5DB',
            margin: '10px 0 6px',
          }}
        />

        <div style={{ ...styles.row, ...styles.rowDivider }}>
          <div style={styles.leftIcon}>
            <AccessTimeOutlinedIcon
              style={{ fontSize: 16, color: '#6B7280' }}
            />
          </div>

          <div style={styles.rowTexts}>
            <div style={styles.title}>Expira após</div>
            <div style={styles.desc}>Dias até o link se tornar inválido</div>
          </div>

          <div style={styles.rightControl}>
            <button
              type="button"
              onClick={() => commitExpireValue(Number(expireDays || 0) - 1)}
              style={styles.stepBtn}
              aria-label="Diminuir dias"
              disabled={loading}
            >
              −
            </button>

            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={expireInput}
              onChange={e => {
                const onlyDigits = e.target.value.replace(/[^\d]/g, '');
                setExpireInput(onlyDigits);
              }}
              onBlur={() => {
                commitExpireValue(expireInput || 0);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.currentTarget.blur();
                }
              }}
              style={styles.numberInput}
              disabled={loading}
            />

            <button
              type="button"
              onClick={() => commitExpireValue(Number(expireDays || 0) + 1)}
              style={styles.stepBtn}
              aria-label="Aumentar dias"
              disabled={loading}
            >
              +
            </button>

            <span style={{ fontSize: 12, color: '#6B7280' }}>dias</span>
          </div>
        </div>

      </Card>

      <div style={styles.footer}>
        <Button
          variant="secondary"
          onClick={onCancel}
          style={{ minWidth: 120 }}
          disabled={loading}
        >
          <Text type="regular" weight={500}>
            Cancelar
          </Text>
        </Button>

        <Button
          onClick={() => {
            if (!linkNameFilled && !linkNameTouched) setLinkNameTouched(true);
            onGenerate();
          }}
          style={{ minWidth: 160 }}
          disabled={!linkNameFilled || loading}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <LinkIcon style={{ fontSize: 18 }} />
            <Text type="regular" weight={500}>
              Gerar Link
            </Text>
          </div>
        </Button>
      </div>
    </>
  );
}
